import script from "./SyncTypes.vue?vue&type=script&setup=true&lang=js"
export * from "./SyncTypes.vue?vue&type=script&setup=true&lang=js"

import "./SyncTypes.vue?vue&type=style&index=0&id=489bdf9a&lang=scss&scoped=true"

import exportComponent from "../../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-489bdf9a"]])

export default __exports__